import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20accents%2C%20dramatic%20lighting%2C%20luxurious%20atmosphere%2C%20empty%20seats%20with%20soft%20glow%2C%20professional%20architectural%20photography&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="红桃影视"
        title="红桃影视在线观看 - 免费高清影视资源一站畅享"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 max-w-3xl leading-tight">
          免费高清影视资源<br className="hidden sm:block" />一站畅享
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
          最新电影、热门电视剧、综艺动漫，无需下载即可流畅播放。多线路切换，告别卡顿，随时随地享受极致观影体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white px-8 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}